import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { MuiTypography } from '../material-ui';
import { CaptureClicksRichText } from '../RichText';
import TwoColumnContent from '../TwoColumnContent';
import { SolutionsSummaryProps } from './SolutionsSummary.interface';
import useStyles from './SolutionsSummary.styles';

const SolutionsSummary = ({
  theme,
  stats = [],
  content = [],
}: PropsWithChildren<SolutionsSummaryProps>) => {
  const classes = useStyles({});

  const rootClasses = clsx(classes.root, `${theme}-theme`);

  return (
    <div data-testid="qa-solutions-summary-component" className={rootClasses}>
      <TwoColumnContent
        columnRatio="30-70"
        leftColumn={
          <>
            {stats.length > 0 && (
              <div className={clsx('qa-solutions-summary-stats', classes.stats)}>
                {stats.map((item) => (
                  <div key={item.pretitle} className={classes.stat}>
                    <MuiTypography
                      variant="caption"
                      component="div"
                      data-testid="qa-solutions-summary-pretitle"
                      className={classes.pretitle}
                    >
                      {item.pretitle}
                    </MuiTypography>

                    <MuiTypography
                      variant="h4"
                      component="h4"
                      data-testid="qa-solutions-summary-title"
                    >
                      {item.title}
                    </MuiTypography>
                  </div>
                ))}
              </div>
            )}
          </>
        }
        rightColumn={
          <>
            {content.length > 0 && (
              <div className={clsx('qa-solutions-summary-text', classes.summaryText)}>
                {content.map((contentItem) => (
                  <div key={contentItem.superHeading}>
                    {contentItem.superHeading && (
                      <MuiTypography
                        variant="overline"
                        component="div"
                        data-testid="qa-solutions-summary-superheading"
                        className={clsx(
                          classes.superHeading,
                          classes[contentItem.superHeadingColor],
                        )}
                      >
                        {contentItem.superHeading}
                      </MuiTypography>
                    )}
                    {contentItem.content && (
                      <CaptureClicksRichText
                        customStyles
                        data-testid="qa-solutions-summary-rich-text"
                        content={contentItem.content}
                        className={classes.richText}
                        theme={theme}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}
          </>
        }
      />
    </div>
  );
};

export default memo(SolutionsSummary);
